import { SportType } from 'modules/core/domain/enums/sport-type';
import { TournamentListItemDataMapper } from 'modules/tournaments/domain/data-mappers/tournament-list-item.data-mapper';
import {
  TournamentListItem,
  TournamentListItemDto,
  TournamentsListResponseDto,
} from 'modules/tournaments/domain/interfaces/tournament-list-item';
import { baseApi } from 'shared/api/base-api';

export interface ListTournamentsArgs {
  text?: string;
  phone?: string;
  sportType?: SportType;
  sortByCreatedAt?: string;
  limit: number;
  offset: number;
}

const LIST_TOURNAMENTS_QUERY = `#graphql
query listTournaments($input: TournamentsInput!) {
  tournaments(input: $input) {
    id
    name
    sportType
    phone
    email
    createdAt
    description
    images { type externalUrl createdAt }
    address { id city country }
    adminUser {
      id name surname middleName
      createdAt updatedAt
      wallet { balanceInMinorUnits }
    }
  }
}
`;

const tournamentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listTournaments: build.query<TournamentListItem[], ListTournamentsArgs>({
      query: (args) => ({
        query: LIST_TOURNAMENTS_QUERY,
        variables: {
          input: {
            text: args.text,
            phone: args.phone,
            sportType: args.sportType,
            sortByCreatedAt: args.sortByCreatedAt,
            limit: args.limit,
            offset: args.offset,
          },
        },
      }),
      transformResponse: (raw: TournamentsListResponseDto): TournamentListItem[] => {
        const mapper = new TournamentListItemDataMapper();
        return (raw.tournaments ?? []).map((dto: TournamentListItemDto) => mapper.decode(dto));
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map((item) => ({ type: 'Tournament' as const, id: item.id })),
              { type: 'Tournament' as const, id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Tournament' as const, id: 'PARTIAL-LIST' }],
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useListTournamentsQuery } = tournamentsApi;
